import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Axios from '../../lib/axios/axiosInstance';
import Loader from '../Common/loader';
import * as AuthVerify from '../../lib/common';
import "./MyReview.styles.css";

const MyReview = () => {

  const [reviews, setReviews] = useState(false);

  useEffect(async () => {
    // Get My Reviews
    // /api/account/productreview
    await Axios.get(`/account/productreview`)
      .then(function (response) {
        if (response && response.data?.data?.reviews) {
          setReviews(response.data?.data?.reviews)
        }
      })
  }, [])

  const Review = () => {
    return (
      <div className="box visible">
        <ul>
          {reviews ? reviews.map((review, i) => {
            return (
              <li key={i} className="even">
                <div className="col-md-4" style={{ textAlign: 'center' }}>
                  <a href={`/product-detail?matnum=${review.matnum}`}>
                    <img style={{ maxHeight: "130px" }} src={AuthVerify.getImageLink(review.imageurl)} alt="Product" />
                  </a>
                  <br />
                </div>
                <div className="col-md-4">
                  <div className="review review-2">
                    <br />
                    <h6>
                      <Link to={`/product-detail?matnum=${review.matnum}`}>{review.matname}</Link>
                    </h6>
                    <small>
                      Review by <span>{review.nickname} </span>on {review.createdat.split('T')[0]}
                    </small>
                    <div>
                      Summary: {review.summary}
                    </div>
                    <div>
                      Description: {review.content}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  {/* <table className="ratings-table-2" style={{ width: "25% !important" }}>
                    <colgroup>
                      <col width="1">
                      </col>
                    </colgroup>
                    <tbody>
                      <tr>
                        <th style={{ width: "100%" }}>Product Name</th>
                        <td><div className="rating-box">
                          <div className="rating" style={{ width: "100%" }}></div>
                        </div></td>
                      </tr>
                      <tr>
                        <th style={{ width: "100%" }}>Value</th>
                        <td><div className="rating-box">
                          <div className="rating" style={{ width: "100%" }}></div>
                        </div></td>
                      </tr>
                      <tr>
                        <th style={{ width: "100%" }}>Quality</th>
                        <td><div className="rating-box">
                          <div className="rating" style={{ width: "100%" }}></div>
                        </div></td>
                      </tr>
                      <tr>
                        <th style={{ width: "100%" }}>Price</th>
                        <td><div className="rating-box">
                          <div className="rating" style={{ width: "80%" }}></div>
                        </div></td>
                      </tr>
                    </tbody>
                  </table> */}
                  <table className="ratings-table-2 data-table" style={{ width: "100% !important" }}>
                    <colgroup>
                      <col />
                      <col width="1" />
                      <col width="1" />
                      <col width="1" />
                      <col width="1" />
                      <col width="1" />
                    </colgroup>
                    <thead>
                      <tr className="first last">
                        <th>&nbsp;</th>
                        <th>
                          <span className="nobr">1 *</span>
                        </th>
                        <th>
                          <span className="nobr">2 *</span>
                        </th>
                        <th>
                          <span className="nobr">3 *</span>
                        </th>
                        <th>
                          <span className="nobr">4 *</span>
                        </th>
                        <th>
                          <span className="nobr">5 *</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="first odd">
                        <th>Price </th>
                        <td className="value">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_price > 0}
                          />
                        </td>
                        <td className="value">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_price > 1}

                          />
                        </td>
                        <td className="value">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_price > 2}

                          />
                        </td>
                        <td className="value">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_price > 3}

                          />
                        </td>
                        <td className="value last">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_price > 4}

                          />
                        </td>
                      </tr>
                      <tr className="even">
                        <th>Value </th>
                        <td className="value">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_value > 0}

                          />
                        </td>
                        <td className="value">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_value > 1}
                          />
                        </td>
                        <td className="value">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_value > 2}
                          />
                        </td>
                        <td className="value">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_value > 3}
                          />
                        </td>
                        <td className="value last">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_value > 4}
                          />
                        </td>
                      </tr>
                      <tr className="last odd">
                        <th>Quality </th>
                        <td className="value">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_quality > 0}
                          />
                        </td>
                        <td className="value">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_quality > 1}
                          />
                        </td>
                        <td className="value">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_quality > 2}
                          />
                        </td>
                        <td className="value">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_quality > 3}
                          />
                        </td>
                        <td className="value last">
                          <input
                            Type="radio"
                            className="radio"
                            checked={review.rate_quality > 4}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/* <div className="review review-2" style={{ width: "73% !important" }}>
                    <h6>
                      <Link to={`/product-detail?matnum=${review.matnum}`}>{review.matname}</Link>
                    </h6>
                    <div>
                      {review.summary}
                    </div>
                    <small>
                      Review by <span>{review.nickname} </span>on {review.createdat.split('T')[0]}
                    </small>
                    <div className="review-txt">
                      {review.content}
                    </div>
                  </div> */}
                </div>

              </li>
            )
          }) : <Loader />
          }
        </ul>
      </div>
    )
  }
  return (
    <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>My Reviews</h2>
          {/* <p>Loremn osum doky sit conseete,tut ugiscirq elit. Maecenas quis ex elei'end enim eget. eleifeod gwus. Oonec quis condenentum fin bus
                  </p> */}
        </div>
        <div id="reviews_tabs">
          <div className="box-collateral box-reviews" id="customer-reviews">
            <div className="box-reviews2">
              <Review />
            </div>
            <div className="clear"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyReview;
